import React from 'react';
import type { IconProps } from '../types';

export const OHIFLogo = (props: IconProps) => (
  <svg
    width="140px"
    height="44px"
    viewBox="0 0 140 44"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <image
      href="/assets/ctroi-logo.jpeg"
      x="0"
      y="0"
      width="44"
      height="44"
      style={{ filter: 'drop-shadow(0 0 3px rgba(59,130,246,0.6))' }}
    />
    <text
      x="52"
      y="28"
      fontFamily="sans-serif"
      fontSize="22"
      fontWeight="bold"
      fill="#FFFFFF"
      letterSpacing="2"
    >
      CTROI
    </text>
  </svg>
);

export default OHIFLogo;
